// helpers
import { EVENT_NAMES } from 'shared/helpers/utils/impressions/constants';
import {
  landingPageRegex,
  ListingPageRegex,
  DetailsPageRegex,
  offerPageRegex,
  SearchPageRegex,
} from 'shared/helpers/utils/regex';
import { onClickInteraction } from 'shared/layouts/Listing/components/Analytics/helpers';

const getPageName = () => {
  var path = window.location.pathname;

  if (path === '/') {
    return 'home';
  }

  if (landingPageRegex.test(path)) {
    return 'landing';
  }

  if (ListingPageRegex.test(path)) {
    return 'category_lising';
  }

  if (DetailsPageRegex.test(path)) {
    return 'product';
  }

  if (offerPageRegex.test(path)) {
    return 'offer';
  }

  return 'other';
};

export const onClickSendEvent = (data: Record<string, any>) => {
  var path = window.location.pathname;

  // if Intercation done on PLP
  if (ListingPageRegex.test(path) || SearchPageRegex.test(path)) {
    onClickInteraction();
  }

  // retina
  if (!window.na) {
    return;
  }

  const retinaData = {
    event_type: 'click',
    page_name: getPageName(),
    dn_page_type: data['namespace0'] || undefined,
    dn_page_section: data['namespace1'] || undefined,
    dn_tile_id: data['namespace2'] || undefined,
    dn_inventory_position: data['position1'] || undefined,
    dn_tile_position: data['position2'] || undefined,
    dn_transaction_id: data['transaction_id'] || undefined,
    dn_request_page_data: '',
    dn_inventory_page_data: data['inventoryPageData'] || undefined,
  };

  window.na.sendEvent(EVENT_NAMES.BANNER_CLICK, retinaData);
};

export const onImpressionEvent = (data: Record<string, any> & { transaction_id: string }) => {
  if (!window.na) {
    return;
  }

  const dwhData = {
    page_name: getPageName(),
    dn_impressions: data['impressions'] || undefined,
    dn_page_type: data['namespace0'] || undefined,
    dn_page_section: data['namespace1'] || undefined,
    dn_tile_id: data['namespace2'] || undefined,
    dn_inventory_position: data['position1'] || undefined,
    dn_tile_position: data['position2'] || undefined,
    dn_transaction_id: data['transaction_id'] || undefined,
  };

  // we could not use the DTM layer as by the time launch triggers DWH impression bannerData
  // variable is mutated causing wrong impression count
  window.na.sendImpressionEvent(EVENT_NAMES.BANNER_IMPRESSION, dwhData);
};
